const imageExtensionsValid = ['png', 'jpg', 'jpeg', 'heif', 'webm', 'heic'];
export default imageExtensionsValid;
